import React, { Component } from 'react'
import { Container, Title, Content } from './styles'
import { Cross } from '../Icons'

class Question extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false
    }
  }

  render() {
    const { question } = this.props
    return (
      <Container active={this.state.active}>
        <Title active={this.state.active} onClick={() => {this.setState({active: !this.state.active})}}>
          {question.title.rendered}
          <Cross size="" />
        </Title>
        <Content dangerouslySetInnerHTML={{__html: question.content.rendered}} active={this.state.active} />
      </Container>
    )
  }
}

export default Question


// WEBPACK FOOTER //
// ./src/components/Question/index.js